import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Typography, Grid } from '@material-ui/core';
import { useProductContainerStyles } from './style';
import noImage from '../../../assets/noImage.png';
import {
  formatDateWithoutTime,
  priceFormatter,
} from '../../../helpers/ProductHelper';

const ProductPreview = ({ ...props }) => {
  const { mobile, testId } = props;
  const { image, title, orderId, sku, price, purchaseDate } = useSelector(
    (state) => state.issuesSlice,
  );
  const classes = useProductContainerStyles({ mobile });

  return (
    <Box className={classes.boxContainer} data-testid={testId}>
      <img className={classes.image} src={image ? image : noImage} alt="" />
      <Grid container className={classes.textContainer}>
        <Grid item md={12} xs={12}>
          <Typography className={classes.title}>{title}</Typography>
        </Grid>

        <Grid className={classes.grid} item md={6} xs={12}>
          {!mobile && (
            <Typography className={classes.text}>
              <strong>Nº de compra:</strong> {orderId}
            </Typography>
          )}
        </Grid>

        <Grid className={classes.grid} item md={6} xs={12}>
          {!mobile && (
            <Typography className={classes.text}>
              <strong>Total de compra:</strong> {priceFormatter(price)}
            </Typography>
          )}
        </Grid>

        <Grid className={classes.grid} item md={6} xs={12}>
          <Typography className={classes.text}>
            <strong>SKU:</strong> {sku}
          </Typography>
        </Grid>

        <Grid className={classes.grid} item md={6} xs={12}>
          <Typography className={classes.text}>
            <strong>Fecha de compra:</strong>{' '}
            {formatDateWithoutTime(purchaseDate)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

ProductPreview.propTypes = {
  mobile: PropTypes.bool,
  testId: PropTypes.string,
};

export default ProductPreview;
